import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Set your password", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Login to your account", -1)
const _hoisted_5 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Heading),
    (!_ctx.passwordStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (_ctx.docid)
            ? (_openBlock(), _createBlock(_component_Form, {
                key: 0,
                fields: _ctx.fields,
                buttons: _ctx.buttons,
                onFormHasPassedValidation: _ctx.saveFormData
              }, null, 8, ["fields", "buttons", "onFormHasPassedValidation"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_router_link, {
            to: { name: 'Login' },
            custom: ""
          }, {
            default: _withCtx(({ href, navigate }) => [
              _createElementVNode("a", {
                href: href,
                onClick: navigate,
                role: "button",
                draggable: "false",
                class: "govuk-button",
                "data-module": "govuk-button"
              }, " Sign in ", 8, _hoisted_5)
            ]),
            _: 1
          })
        ]))
  ], 64))
}